import React, { createContext, ReactNode, useContext } from "react";

import { Experience } from "@/utils/experience";

const ExperienceContext = createContext<
  Partial<Experience> & { screenshot: boolean; screenshotSet: (screenshot: boolean) => void }
>({
  screenshot: false,
  screenshotSet: () => {}
});

export const ExperienceProvider: React.FC<{
  experience: Partial<Experience>;
  children: ReactNode;
}> = ({ experience, children }) => {
  const [screenshot, screenshotSet] = React.useState(false);

  return (
    <ExperienceContext.Provider value={{ ...experience, screenshotSet, screenshot }}>
      {children}
    </ExperienceContext.Provider>
  );
};

export const useExperience = () => {
  const context = useContext(ExperienceContext);

  if (!context) {
    throw new Error("useExperience must be used within an ExperienceProvider");
  }

  return context;
};
